var _defs, _rect, _path, _rect2, _path2, _path3, _rect3, _rect4, _path4, _path5, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFreelanceLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 118.17 53.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:#fff;}.cls-5{clip-path:url(#clip-path);}.cls-6{fill:url(#linear-gradient-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 73.39,
    y1: 8.92,
    x2: 77.08,
    y2: 8.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#49a8bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#49a8bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#466ab0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 8.01,
    y1: 11.75,
    x2: 71.41,
    y2: 11.75,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.36,17.21l11,6.17c5.69-2.6,19.36-1.89,31.34,10.42.36.43,1.32,1.59,1.81,2.27.95,1.43,1.87,3,2.77,4.58-1.07-.88-2.74-2.18-4.94-3.68-1-.67-2.06-1.36-3.23-2.08q-.87-.53-1.81-1.06l-1-.55c-11-6-27.95-11.44-44.06-1.32l0,0a44.22,44.22,0,0,0-6.92,5c-.63.57-2.32,2-3,2.52-9.45,6.86-13,8.28-15,9-.63.19-1.27.36-1.9.5-11.7,2.36-20.4-1.93-23.26-5.7L.61,43.53C3.51,48.32,14.78,54.4,30.18,50.9h0s2.56-.51,5-1.21h0l.1,0,.56-.16.7-.22c.58-.19,1.11-.38,1.57-.58h0c2.91-1.12,7.44-3.34,14.22-8.81.37-.27.9-.69.9-.69.48-.4,1-.84,1.46-1.26l.5-.42h0l.43-.37c17.76-16.09,38-5.63,47,.6A67.5,67.5,0,0,1,108.07,42h2.32l7.19-.17a58.57,58.57,0,0,0-5.08-7.35C101.17,19.85,87.67,15.27,78.33,15.27a18.27,18.27,0,0,0-9,1.95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -414.84,
    y1: 2185.6,
    x2: -413.84,
    y2: 2185.6,
    gradientTransform: "matrix(116.97, 0, 0, -116.97, 48525.78, 255690.21)",
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 73.39,
    y: 0.94,
    width: 3.68,
    height: 15.96
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M67.71,10.67c0,1.26-.36,2.76-2.08,2.76H52.27a19.26,19.26,0,0,1-.11-2.16c0-.34,0-1.39,1.55-1.39H60.4V6.56h-7A4.2,4.2,0,0,0,48.93,11c0,.76,0,1.59.12,2.4H38.69c.05-.61.09-1.22.09-1.83,0-3.13-2.2-5.26-5.49-5.31a5.08,5.08,0,0,0-5.38,5.24A17.19,17.19,0,0,0,28,13.65H18.83V.94H15.19V16.61c0,1.58-.59,2.38-1.75,2.38A11.08,11.08,0,0,1,10,18.35L8.82,18,8,21.36l1,.35a12.7,12.7,0,0,0,4.44.85c3.21,0,5.23-2.14,5.37-5.59H35.2l31.4.09h-.7v0c3.41-.12,5.52-2.53,5.52-6.38V.94h-3.7Zm-36.56,3a11.72,11.72,0,0,1-.1-1.81v-.16a2,2,0,0,1,2.19-2.07c1.08,0,2.38.37,2.38,2.16a16,16,0,0,1-.1,1.88Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 73.39,
    y: 18.91,
    width: 3.68,
    height: 16.08
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M67.71,28.66c0,1.26-.36,2.76-2.08,2.76H50.19c.06-.69.09-1.39.09-2a4.2,4.2,0,0,0-4.49-4.47H39.5v3.32h6c1.55,0,1.55,1,1.55,1.39a18.22,18.22,0,0,1-.11,2.1H18.6V27.39H15.23v8.23c0,1.15-.33,2.51-1.89,2.51a11.19,11.19,0,0,1-3.46-.64l-1.06-.34-.74,3.13.88.31a12.6,12.6,0,0,0,4.39.84c3.25,0,5.26-2.23,5.26-5.83V35H65.83c3.45-.09,5.58-2.52,5.58-6.39V18.91h-3.7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M112.5,34.44c-16-20.6-36.31-21.24-43.14-17.22l11,6.17c5.69-2.6,19.36-1.89,31.34,10.42.36.43,1.32,1.59,1.81,2.27.95,1.44,1.87,3,2.77,4.58-1.07-.88-2.74-2.18-4.94-3.68-1-.67-2.06-1.36-3.23-2.08q-.87-.53-1.81-1.06l-1-.55c-11-6-27.95-11.44-44.06-1.32l0,0a44.16,44.16,0,0,0-6.92,5c-.63.57-2.32,2-3,2.52-9.44,6.87-13,8.28-15,9-.63.19-1.27.36-1.9.5C22.75,51.33,14.06,47,11.2,43.28L.61,43.53C3.52,48.32,14.78,54.4,30.18,50.9h0s2.56-.51,5-1.21l.1,0,.56-.17c.23-.07.45-.13.7-.22.58-.19,1.11-.39,1.57-.58h0c2.92-1.12,7.44-3.34,14.22-8.81l.9-.69c.48-.4,1-.84,1.46-1.26l.5-.42h0l.43-.37c17.76-16.09,38-5.63,47,.6A67.8,67.8,0,0,1,108.07,42h2.32l7.19-.17a58.6,58.6,0,0,0-5.08-7.35"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 73.39,
    y: 18.91,
    width: 3.68,
    height: 16.08
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 73.39,
    y: 0.94,
    width: 3.68,
    height: 15.96
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M67.71,10.67c0,1.26-.36,2.76-2.08,2.76H52.27a19.26,19.26,0,0,1-.11-2.16c0-.34,0-1.39,1.55-1.39H60.4V6.56h-7A4.2,4.2,0,0,0,48.93,11c0,.76,0,1.59.12,2.4H38.69c.05-.61.09-1.22.09-1.83,0-3.13-2.2-5.26-5.49-5.31a5.08,5.08,0,0,0-5.38,5.24A17.19,17.19,0,0,0,28,13.65H18.83V.94H15.19V16.61c0,1.58-.59,2.38-1.75,2.38A11.08,11.08,0,0,1,10,18.35L8.82,18,8,21.36l1,.35a12.7,12.7,0,0,0,4.44.85c3.21,0,5.23-2.14,5.37-5.59H35.2l31.4.09h-.7v0c3.41-.12,5.52-2.53,5.52-6.38V.94h-3.7Zm-36.56,3a11.72,11.72,0,0,1-.1-1.81v-.16a2,2,0,0,1,2.19-2.07c1.08,0,2.38.37,2.38,2.16a16,16,0,0,1-.1,1.88Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M67.71,28.66c0,1.26-.36,2.76-2.08,2.76H50.19c.06-.69.09-1.39.09-2a4.2,4.2,0,0,0-4.49-4.47H39.5v3.32h6c1.55,0,1.55,1,1.55,1.39a18.22,18.22,0,0,1-.11,2.1H18.6V27.39H15.23v8.23c0,1.15-.33,2.51-1.89,2.51a11.19,11.19,0,0,1-3.46-.64l-1.06-.34-.74,3.13.88.31a12.6,12.6,0,0,0,4.39.84c3.25,0,5.26-2.23,5.26-5.83V35H65.83c3.45-.09,5.58-2.52,5.58-6.39V18.91h-3.7Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 0.61,
    y: 15.27,
    width: 116.97,
    height: 39.14
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreelanceLogoWhite);
export default __webpack_public_path__ + "static/media/freelance_logo_white.60e303a7090bea0e702243f684490d86.svg";
export { ForwardRef as ReactComponent };